const TEMPLATES = [
  {
    icon: "bi-bank2",
    iconClass: "bg-[#E8F0FE] text-[#1D4ED8]",
    sector: "Banks",
    title: "Banking consent pack",
    text: "Account opening, KYC, credit assessment, marketing and third-party sharing notices aligned to banking operations.",
    tags: ["KYC", "Credit", "Cross-sell"],
  },
  {
    icon: "bi-graph-up-arrow",
    iconClass: "bg-[#E6F7F3] text-[#0B8F7A]",
    sector: "BFSI",
    title: "BFSI & insurance pack",
    text: "Insurance proposals, claims processing, investment onboarding and partner distribution consents for BFSI journeys.",
    tags: ["Insurance", "Investments", "Claims"],
  },
  {
    icon: "bi-gear-wide-connected",
    iconClass: "bg-[#FEF3C7] text-[#B45309]",
    sector: "Manufacturing",
    title: "Manufacturing pack",
    text: "Worker, visitor and vendor notices — CCTV, biometrics, contractor data and supply-chain processor acknowledgements.",
    tags: ["Workforce", "Visitors", "Vendors"],
  },
  {
    icon: "bi-building",
    iconClass: "bg-[#FCE7F0] text-[#BE185D]",
    sector: "Hotels",
    title: "Hospitality pack",
    text: "Guest registration, loyalty programmes, CCTV, Wi-Fi and marketing consents across property and OTA channels.",
    tags: ["Guests", "Loyalty", "Wi-Fi"],
  },
  {
    icon: "bi-heart-pulse",
    iconClass: "bg-[#FFECE8] text-[#C2410C]",
    sector: "Hospitals",
    title: "Healthcare pack",
    text: "Patient registration, clinical records, telehealth, billing and research-related notices with sensitive-data care.",
    tags: ["Patients", "Telehealth", "Billing"],
  },
  {
    icon: "bi-briefcase",
    iconClass: "bg-[#F0E8FF] text-[#6B46C1]",
    sector: "Enterprise",
    title: "Enterprise group pack",
    text: "Employee, customer and partner templates for multi-entity groups — shared purposes, group companies and HRIS sync.",
    tags: ["Employees", "Customers", "Group entities"],
  },
];

export default function Templates() {
  return (
    <section id="templates" className="py-20 bg-surface border-b border-line">
      <div className="container mx-auto max-w-[1140px] px-4">
        <p className="inline-block text-[0.78rem] font-semibold tracking-[0.12em] uppercase text-teal mb-[0.85rem]">
          Industry template library
        </p>
        <h2 className="font-bricolage text-[clamp(1.75rem,3vw,2.3rem)] mb-[0.7rem] text-ink">
          Start fast with ready-to-use consent templates
        </h2>
        <p className="text-[1.05rem] leading-[1.65] text-slate max-w-[40rem]">
          Sector-ready consent and notice packs — Banks, BFSI, Manufacturing,
          Hotels, Hospitals and Enterprise — all in one library. Customise
          purposes and language, then publish across portals, Email and
          WhatsApp.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[1.15rem] mt-11">
          {TEMPLATES.map((t) => (
            <div
              key={t.title}
              className="flex flex-col h-full bg-white border border-line rounded-[10px] p-[1.45rem_1.35rem] transition-all hover:-translate-y-[3px] hover:border-gold/[.55]"
            >
              <div className={`w-[46px] h-[46px] rounded-[11px] flex items-center justify-center text-[1.2rem] mb-[0.95rem] ${t.iconClass}`}>
                <i className={`bi ${t.icon}`} />
              </div>
              <div className="text-[0.68rem] font-bold tracking-[0.1em] uppercase text-teal mb-[0.35rem]">
                {t.sector}
              </div>
              <h3 className="text-[1.08rem] font-bricolage font-semibold mb-[0.4rem]">{t.title}</h3>
              <p className="m-0 mb-4 text-[0.9rem] text-slate leading-[1.5] flex-1">{t.text}</p>
              <div className="flex flex-wrap gap-[0.4rem]">
                {t.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-[0.7rem] font-semibold px-2 py-[0.22rem] rounded bg-surface border border-line text-slate-2"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
